export const PDF_BORDER = {
  THIN: '1px solid black',
  NORMAL: '2px solid black',
  BOLD: '3px solid black',
} as const;

export const PDF_FONT_SIZE = {
  XS: 5,
  SM: 6,
  MD: 7,
  LG: 9,
  XL: 12,
} as const;

export const PDF_HEADER_BACKGROUND_COLOR = '#eeeeee';

export const SECTION_TITLE_BACKGROUND_COLOR = 'rgba(0, 0, 0, 0.25)';
export const SECTION_ITEM_PADDING = '2px 8px';
export const SECTION_FONT_SIZE = 12;

export const REPORT_BORDER_COLOR = {
  primary: '#000',
  secondary: '#7d7d7d',
} as const;
